"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canSubmitLabel = void 0;
var INDICATOR_MAXIMUM_MESSAGE_LENGTH = 4000;
function canSubmitLabel(params) {
    var message = params.message, active = params.active;
    if (message.length > INDICATOR_MAXIMUM_MESSAGE_LENGTH) {
        return 'TOOLONG';
    }
    if (!(message.trim())) {
        return !active ? 'DELETE' : 'NOMESSAGE';
    }
    return 'SUBMIT';
}
exports.canSubmitLabel = canSubmitLabel;
//# sourceMappingURL=canSubmitLabel.js.map